"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9068],{

/***/ 9068:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GarageProfileMapLocation": function() { return /* binding */ GarageProfileMapLocation; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _eo_locale_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7245);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);




var GarageProfileMap = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9269), __webpack_require__.e(8085), __webpack_require__.e(135), __webpack_require__.e(6889), __webpack_require__.e(7953), __webpack_require__.e(5639)]).then(__webpack_require__.bind(__webpack_require__, 3221));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3221)
            ];
        }
    },
    ssr: false
});
var GarageProfileMapLocation = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.memo(function(param) {
    var garage = param.garage;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        id: "garage-location",
        className: "col-span-full mb-6 md:mb-8",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                className: "text-3xl leading-9 text-gray-900 font-serif mb-8",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_eo_locale_react__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .xv, {
                        id: "profileBody_location_headline"
                    }),
                    " ",
                    garage.name
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full h-[320px] rounded-md",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GarageProfileMap, {
                    garage: garage
                })
            })
        ]
    });
});
GarageProfileMapLocation.displayName = "GarageProfileMapLocation";


/***/ })

}]);